import { dateFormat } from 'design-system';
import { EmissionData } from '../../YappyEmissionRequest';
import { EvicertiaRequest } from '../../EvicertiaRequest';

export const makeEvicertiaRequest = (
  emissionData: EmissionData,
  profileId: number,
): EvicertiaRequest => {
  // Properties for evicertia submit to get the uniqueId and redirect URL
  const { salesEmissionRequest } = emissionData;
  const quotationHash = emissionData.urlSalt;
  const validSince = dateFormat.dateFromServerString(
    salesEmissionRequest.validSince,
  );

  return {
    email: salesEmissionRequest.client.email,
    firstName: salesEmissionRequest.client.firstName,
    lastName: salesEmissionRequest.client.lastName,
    profileId,
    quotationHash,
    validSince,
    clientId: salesEmissionRequest.client.id,
    idType: salesEmissionRequest.client.idType,
    serialChassis: salesEmissionRequest.unitInformation.serialVin,
    driver: {
      firstName: salesEmissionRequest.units[0].unit.driver.firstName,
      lastName: salesEmissionRequest.units[0].unit.driver.lastName,
    },
  };
};

export default makeEvicertiaRequest;
